// extracted by mini-css-extract-plugin
export var equalColumn = "_dy-0";